import React, { useState, useEffect } from 'react';
import axios from 'axios';


function Services() {
  const [services, setServices] = useState([]);
  const [error, setError] = useState(null); // To handle errors, if any.
const link = "https://raw.githubusercontent.com/mallikarjunmelkundi/Construction/refs/heads/main/services.json"
  useEffect(() => {
    // Fetch data using axios
    axios.get(link)
      .then(response => {
        setServices(response.data); // Set fetched data to services state
      })
      .catch(error => {
        console.error('Error fetching services data:', error);
        setError('Failed to fetch services'); // Handle error
      });
  }, []);

  return (
    <section id="services" className="py-16 bg-gray-300">
      <div className="container mx-auto text-center px-4">
        <h2 className="text-3xl font-bold mb-8 inline-block border-4 bg-blue-600 border-blue-700 rounded-lg p-2">OUR SERVICES</h2>
        {error ? ( // Display error if fetching fails
          <p className="text-red-500">{error}</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 ">
            {services.map((service, index) => (
              <div id='mall' key={index} className="bg-gray-100 p-4 text-red-900 hover:shadow-lg hover:shadow-blue-500 border border-purple-500 rounded-2xl">
                <h3 className= "bg-gradient-to-r from-purple-500 to-purple-700 text-white text-2xl font-semibold py-2 px-4 shadow-md rounded-md transition duration-300 ease-in-out transform  hover:from-purple-400 hover:to-purple-600">{service.title}</h3>
                <p className="text-pretty text-xl">{service.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default Services;

